import FinalBox from '../lib/FinalBox.class.js';

document.addEventListener('report', (e) => {

	FinalBox.fromString( e.detail.payload.markup );

});


